// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Modal = require("../../../../shared-browser/src/components/BrowserComponents_Modal.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");

var modal = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textAlign("center"),
      tl: /* [] */0
    });

var header = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems("center"),
      tl: /* [] */0
    });

var title = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Blue */0,
                _0: /* Darkest */0
              }),
          tl: {
            hd: BrowserStyle.margin("zero"),
            tl: /* [] */0
          }
        }));

var description = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var Styles = {
  modal: modal,
  header: header,
  title: title,
  description: description
};

function WebComponents_SettingsModal(Props) {
  var cancelButtonTitleOpt = Props.cancelButtonTitle;
  var confirmButtonTitle = Props.confirmButtonTitle;
  var description$1 = Props.description;
  var disabled = Props.disabled;
  var onConfirm = Props.onConfirm;
  var onCancel = Props.onCancel;
  var showError = Props.showError;
  var title$1 = Props.title;
  var cancelButtonTitle = cancelButtonTitleOpt !== undefined ? cancelButtonTitleOpt : "Nevermind";
  return React.createElement(BrowserComponents_Modal.Legacy.make, {
              children: null,
              className: modal
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: header,
                  children: React.createElement(BrowserComponents_Text.make, {
                        className: title,
                        children: title$1
                      })
                }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                  className: description,
                  text: description$1
                }), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* Primary */0,
                  disabled: disabled,
                  onClick: (function (param) {
                      return onConfirm;
                    }),
                  title: confirmButtonTitle
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* LegacySecondary */2,
                  disabled: disabled,
                  onClick: (function (param) {
                      return onCancel;
                    }),
                  title: cancelButtonTitle
                }), showError ? React.createElement(BrowserComponents_ValidationError.make, {
                    validationResult: Relude_Option.pure(Relude_Result.error("There was an error. Please try again or contact support."))
                  }) : null);
}

var make = WebComponents_SettingsModal;

exports.Styles = Styles;
exports.make = make;
/* modal Not a pure module */
